// moment and date methods moved to DateUtils
// import * as moment from 'moment';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Utils = (function () {
    function Utils() {
    }
    /*
     * Function to get Site Collection URL
     * Samples:
     *      "https://domain.sharepoint.com/sites/intranet"
     */
    Utils.getSiteCollectionUrl = function () {
        if (window
            && "location" in window
            && "protocol" in window.location
            && "pathname" in window.location
            && "host" in window.location) {
            var baseUrl = window.location.protocol + "//" + window.location.host;
            var pathname = window.location.pathname;
            var siteCollectionDetector = "/sites/";
            if (pathname.indexOf(siteCollectionDetector) >= 0) {
                baseUrl += pathname.substring(0, pathname.indexOf("/", siteCollectionDetector.length));
            }
            return baseUrl;
        }
        return null;
    };
    /*
     * Function to get Current Site Url
     * Samples:
     *      "https://domain.sharepoint.com/sites/intranet/subsite/Pages/Home.aspx"
     */
    Utils.getCurrentAbsoluteSiteUrl = function () {
        if (window
            && "location" in window
            && "protocol" in window.location
            && "pathname" in window.location
            && "host" in window.location) {
            return window.location.protocol + "//" + window.location.host + window.location.pathname;
        }
        return null;
    };
    /*
     * Function to get Current Site Url
     * Samples:
     *      "/sites/intranet"
     */
    Utils.getWebServerRelativeUrl = function () {
        if (window
            && "location" in window
            && "pathname" in window.location) {
            return window.location.pathname.replace(/\/$/, "");
        }
        return null;
    };
    /*
     * Function to get Layout Page Url
     * Replacement in SPFx for SP.Utilities.Utility.getLayoutsPageUrl('sp.js')
     * Samples:
     *      getLayoutsPageUrl('sp.js')
     *      "/sites/intranet/_layouts/15/sp.js"
     */
    Utils.getLayoutsPageUrl = function (libraryName) {
        if (window
            && "location" in window
            && "pathname" in window.location
            && libraryName !== "") {
            return window.location.pathname.replace(/\/$/, "") + "/_layouts/15/" + libraryName;
        }
        return null;
    };
    /*
     * Function to get Current Domain Url
     * Samples:
     *      "https://domain.sharepoint.com"
     */
    Utils.getAbsoluteDomainUrl = function () {
        if (window
            && "location" in window
            && "protocol" in window.location
            && "host" in window.location) {
            return window.location.protocol + "//" + window.location.host;
        }
        return null;
    };
    /* Function to measure scrollbar width
    */
    Utils.findScrollbarWidth = function () {
        // reusing the modal code
        var scrollDiv = document.createElement('div');
        scrollDiv.className = 'scrollbar-measure';
        document.getElementById("s4-workspace").appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.getElementById("s4-workspace").removeChild(scrollDiv);
        return scrollbarWidth;
    };
    /**
     * Function to check if we can use webP
     */
    Utils.canUseWebP = function () {
        var elem = document.createElement('canvas');
        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }
        // very old browser like IE 8, canvas not supported
        return false;
    };
    // DATE PROCESSING FUNCTION FROM SEARCH RESULTS
    /**
     * Replace date/time strings
     * @param inputValue The string to format
     * @param currentUICultureName pass in via the context from the page/webpart
     * 		page layout: _spPageContextInfo.currentUICultureName
     * 		webpart: context.pageContext.cultureInfo.currentUICultureName
     * @param format The output format for Date (moment specific)0
     */
    // moment and date methods moved to DateUtils
    // public static _formatDate(inputValue: string, currentUICultureName: string, format: string): string {
    // 	moment.locale(currentUICultureName);
    // 	let localeFormat = moment.localeData().longDateFormat('L');
    // 	let d = moment(inputValue, localeFormat);
    // 	return d.format(format);
    // }
    /**
     * Funtion to position the web part editor pane relative to the web part being edited
     *
     * Sample 1:
     * positionPanel(), 3000);
     *
     */
    Utils.positionPanel = function () {
        var panel = document.getElementById('MSOTlPn_Tbl');
        if (!panel) {
            // no wp editors are open, exit function
            return;
        }
        else {
            var wpzone = document.querySelector('div[wptoolpaneopen="true"] > .ms-webpart-selected');
            var workspace = document.getElementById('s4-workspace');
            // move web part editor pane
            panel.parentNode.removeChild(panel);
            wpzone.appendChild(panel);
            // add styling to position pane
            panel.style.position = 'absolute';
            panel.style.right = '-300px';
            panel.style.top = '-5px';
            wpzone.style.position = 'relative';
            workspace.style.overflowX = 'auto';
            return;
        }
    };
    /**
     *
     * @param tagSpans
     * @param resultsUrl
     *
     * Function to turn metadata tags into anchors
     *
     * Sample 1:
     * createClickableTags(tagSpans, resultsUrl);
     *
     */
    Utils.createClickableTags = function (tagSpans, resultsUrl) {
        if (tagSpans && tagSpans.length > 0) {
            // change tag spans to links
            tagSpans.forEach(function (tag) {
                // create tag anchor element
                var newAnchor = document.createElement("a");
                // create inner content
                var tagContent = document.createTextNode(tag.innerText);
                // add attributes to the new tag anchor element
                // inner content
                newAnchor.appendChild(tagContent);
                // title
                newAnchor.title = tag.innerText;
                // href
                var encodedTag = encodeURIComponent(tag.innerText);
                newAnchor.href = resultsUrl + encodedTag;
                // className
                newAnchor.className = "tag-button";
                // role (for accessibility) - role is not avaialble on HTMLAnchorElement, so use setAttribute instead
                newAnchor.setAttribute("role", "button");
                // add the newly created element and its content into the DOM
                document.getElementById("ttTags").appendChild(newAnchor);
            });
        }
        return;
    };
    /**
     * Function used to show tag section if are tags to display
     * @param contentDom
     * @param parentDom
     */
    Utils.tagSectionCheck = function (contentDom, parentDom) {
        return __awaiter(this, void 0, void 0, function () {
            var tagCheck;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkForContent(contentDom, parentDom)];
                    case 1:
                        tagCheck = _a.sent();
                        // confirm that the custom web part exists
                        if (document.querySelector("#ttTagSection .ms-webpart-chrome")) {
                            if (tagCheck === true) {
                                document.getElementById(parentDom).style.display = "block";
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param contentDoms
     * @param parentDom
     *
     * Function to check for content for a single element or an array of elements
     *
     * Sample 1:
     * if(checkForContent(contentDoms, parentDom) === true) {
         *		// do something
     *	}
     *
     */
    Utils.checkForContent = function (contentDoms, parentDom) {
        var sections = [].concat(contentDoms || []);
        var logic = "";
        for (var i = 0; i < sections.length; i++) {
            var section = document.getElementById(sections[i]);
            if (section && section.textContent.trim()) {
                var statement;
                if (i === 0) {
                    statement = "(section.innerText && section.innerText.length > 0)";
                }
                else {
                    statement = " || (section.innerText && section.innerText.length > 0)";
                }
                logic += statement;
            }
        }
        if (logic) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     *
     * @param contentDomId
     * @param insertDomId
     *
     * Function to process email field into mailto links
     *
     * Sample 1:
     * processMailto("newsMailto", "newsEmail");
     *
     */
    Utils.processMailto = function (contentDomId, insertDomId) {
        var email;
        var mailtoHTML;
        var mailtoDOM = document.getElementById(contentDomId);
        if (!mailtoDOM) {
            return;
        }
        else {
            email = document.getElementById(insertDomId).innerText.trim();
            if (email.length > 0) {
                mailtoHTML = "<a href='mailto:" + email + "' role='button' >" + email + "</a>";
                mailtoDOM.innerHTML = mailtoHTML;
            }
        }
    };
    return Utils;
}());
export { Utils };

//# sourceMappingURL=Utils.js.map
